import { api } from './api';

export interface ExportInfoResponse {
  success: boolean;
  data: {
    maxOldDate: string;
    maxOldDateDisplay: string;
    oldestDataDate: string | null;
    newestDataDate: string | null;
    totalRecords: number;
  };
}

export interface ExportParams {
  type: 'all' | 'custom';
  startDate?: string;
  endDate?: string;
}

export const exportService = {
  /**
   * Get export metadata (date range info)
   */
  async getExportInfo(): Promise<ExportInfoResponse> {
    const response = await api.get<ExportInfoResponse>('/export/info');
    return response.data;
  },

  /**
   * Export sensor data to Excel
   * Triggers file download
   */
  async exportSensorData(params: ExportParams): Promise<void> {
    const queryParams = new URLSearchParams();
    queryParams.append('type', params.type);
    
    if (params.type === 'custom' && params.startDate && params.endDate) {
      queryParams.append('startDate', params.startDate);
      queryParams.append('endDate', params.endDate);
    }

    const response = await api.get(`/export/sensor-data?${queryParams.toString()}`, {
      responseType: 'blob', // Important for file downloads
    });

    // Create download link
    const blob = new Blob([response.data], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    // Extract filename from header or generate default
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'sensor-data.xlsx';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match) {
        filename = match[1];
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export default exportService;
